import React from 'react';
import { graphql, Link } from "gatsby"
import { Container, Row, Col, Breadcrumb } from "react-bootstrap"
import ContentModule from "../modules/content_module";
import Layout from "../components/Layout"
import { breadcrumbs } from "../common/utils/breadcrumbs";
import ImageModule from "../modules/image_module";
import _ from "lodash";
import ContactForm from "../components/ContactForm/StaffContactForm";
import { PageLinks } from "../common/page-links";

const NewsDetailTemplate = ({ data, pageContext }) => {
  const { glstrapi: { team } } = data;

  var type = pageContext?.type

  let meta_data = team?.name ? {title: `${team?.name} ${team?.designation}`, description: `Get to know about ${team?.name} here. Contact one of our estate agents for assistance in finding the right property for you.`} : "";

  const ImageRenderList = ({ item, imagename }) => {
    let processedImages = JSON.stringify({});
    if (item?.imagetransforms?.image_Transforms) {
      processedImages = item?.imagetransforms?.image_Transforms;
    }
    return (
      <ImageModule ImageSrc={item.image} title={item.name} altText={item.name} imagetransforms={processedImages} renderer="srcSet" imagename={imagename} strapi_id={item.id} />
    )
  }

  return (
    <div className={`search-header property-header news-page team-detail-page ${type === "contact-form" ? "contact-field" : ""}`}>

      <Layout seo_meta={meta_data} menu_slug={"meet-the-team"}>

        {type === "contact-form" ?
            <ContactForm data={team}/>
        :
        <section className="branch-banner team-details">
          <Container>
            <Row>
              <Col>
                <div className="branch-wrapper">
                  <div className="branch-img team-img">
                    <ImageRenderList item={team} imagename={"teams.image.details"} />
                    {/* <img src={team?.image?.url} alt={team?.image?.alternativeText} /> */}
                  </div>
                  <div className="content-wrap">
                      <div className="breadcrumb-section">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item d-none"><Link to={`/${PageLinks.teams}/${data?.slug}`} role="button">Back to Team Details</Link></li>
                            <li class="breadcrumb-item"><Link to={"/"} role="button" tabindex="0">Home</Link></li>
                            <li class="breadcrumb-item"><Link to={`/${PageLinks.about}/`} role="button" tabindex="0">About</Link></li>
                            <li class="breadcrumb-item"><Link to={`/${PageLinks.teams}/`} role="button" tabindex="0">Meet the Team</Link></li>
                            <li class="breadcrumb-item last-item"><a href="javascript:;">{team?.name}</a></li>
                        </ol>
                      </div>

                    <div className="branch-content">
                      <h1>{team.name}</h1>
                      <div className="info-wrap">
                        <span> {team.designation}</span>
                      </div>
                    </div>
                    

                    <div className="btn-wrapper d-none d-md-flex">
                      {team.email && <Link to={`/${PageLinks.teams}/${team?.slug}/${PageLinks.team_contact}/`} className="btn"><i className="icon-msg"></i>Email Me</Link> }
                      {team.mobile_no && <a href={`tel:${team.mobile_no}`} className="btn btn-secondary"><i className="icon-call"></i>{team.mobile_no}</a>}
                    </div>
                    <div className='content'>
                      <ContentModule Content={team?.content} />
                    </div>

                  </div>

                </div>
              </Col>
            </Row>

          </Container>
        </section>
        }
      </Layout>
    </div>
  )

}

export default NewsDetailTemplate


export const query = graphql`
query teamDetailQuery($id: ID!) {
    glstrapi { 
      team(id: $id, publicationState: LIVE) {
          id
          name
          mobile_no
          video_url
          email
          designation
          category
          content
          slug
          title
          image {
            alternativeText
            url
          }
          tile_image {
            alternativeText
            url
          }
          imagetransforms
        } 
    }
}`